import { getPageSettings } from "../util/pageSettings";
import { shouldSkipPhoneNumberProcessing } from "../util/phoneNumberReplacement";
import { conceptIdLookupForNblyOrCorp } from "./helper_functions";

export class ConditionalLocalization {
    private static instance: ConditionalLocalization;
    
    private readonly templateCheckSet: Set<string> = new Set([
    'opus 2 agnostic lead flow template',
    'opus 2 agnostic lead flow confirmation page'
    ]);

    private readonly localStorageItemsToDelete: Set<string> = new Set([
        'dbaName',
        'weblocationId',
        'full_dbaName',
        'local_weblocationId',
        'localPhoneNumber',
        'franchiseWebLocationId',
        'doingBusinessAs',
        'alternateConcept',
        'dynamicMenuURLResponse',
        'filterService',
        'dynamicAccorInfo',
        'countryCode',
        'franchiseeName',
        'socialIconsFooter',
        'ourTeamObject',
        'photoGalleryData',
        'franchiseId'
    ]);

    private deleteLocalizedData: boolean = true;

    public static getInstance(){
        this.instance ??= new ConditionalLocalization();
        return this.instance;
    }

    private constructor() {}

    public init(): boolean {
        return this.conditionalLocalize();
    }

    private conditionalLocalize(): boolean {
        if(this.isNblyOrCorp()) {
             if (!this.pageTemplateCheck()){
                console.log("Nbly or Corp brand - not using agnostic template");
                this.deleteLocalization();
                return false;
             }
        }
        this.replaceLogoAndPhone();
        return true;
    }
    
    

    private pageTemplateCheck(): boolean {
        const pageTemplate = getPageSettings('pagetemplate');
        const normalized = (pageTemplate ?? '').trim().toLowerCase();
        if (!normalized) return false;
        return this.templateCheckSet.has(normalized);
    }

    private isNblyOrCorp(): boolean {
        return conceptIdLookupForNblyOrCorp();
    }

    private deleteLocalization(): void {
        if (!this.deleteLocalizedData) {
            return;
        }
        try{

            this.localStorageItemsToDelete.forEach(key => {
                localStorage.removeItem(key);
                sessionStorage.removeItem(key);
            });
        }
        catch(err: unknown) {
            console.error('Error while deleting localization items from storage:', err);
        }
    }

    private replaceLogoAndPhone(){
        const phoneNumb = document.querySelector('.fb-des-para > .fb-tel') as HTMLAnchorElement;
        const brandHeader = document.querySelector(".brand-header") as HTMLElement;
        const brandLogo = brandHeader?.querySelector(".brand-logo-wrapper") as HTMLElement;
        if (brandLogo && window.innerWidth >= 1024) {
            brandLogo.style.display =  "flex";
        }
        if(phoneNumb) {
            this.setMobileNumber(phoneNumb?.innerText);
        }

    }
    public setMobileNumber(phoneNumber: string): HTMLAnchorElement | null {
        const reg =  /(\d{0,3})(\d{0,3})(\d{0,4})/;
        const phoneFormat = String(phoneNumber).replace(/\D/g, '').match(reg);
        const mobNumber = document.querySelector('.fb-des-para > .fb-tel') as HTMLAnchorElement;

        if (phoneFormat && mobNumber && !shouldSkipPhoneNumberProcessing()) {
            mobNumber.innerHTML = `(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`;
            mobNumber.href = `tel:${phoneFormat[1]}${phoneFormat[2]}${phoneFormat[3]}`;
        }
        return mobNumber;
    }

}